exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#838B99",
	"menuActiveText": "#fff",
	"subMenuActiveText": "#409EFF",
	"menuBg": "#1A1A27",
	"menuHover": "#1D273D",
	"subMenuBg": "#1A1A27",
	"subMenuHover": "#1D273D",
	"sideBarWidth": "210px"
};